import api from 'services/api'
import {
GET_VENDOR_BOOKING_LIST,
UPDATE_BOOKING_STATUS,
GET_BOOKING_DETAIL


} from '../endpoints'

export const getVendorBookingList = async (body) => await api.post(GET_VENDOR_BOOKING_LIST, body)
export const getBookingDetail = async (id) => await api.get(`${GET_BOOKING_DETAIL}?id=${id}`)
// export const submitStatus = async (values) =>
//     await api.post(UPDATE_BOOKING_STATUS , values, {
//       headers: {
//         'Content-Type': 'multipart/form-data',
//       },
//     })

    export const submitStatus = async (values, id) => {
        console.log("Submitting status with values:", values); // Add this
        return await api.post(UPDATE_BOOKING_STATUS, values, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
      };